<template>
  <div class="course_list flex FlexWrap FlexBetween">
    <div
      class="flex course_one flexcolumn FlexEvenly"
      v-for="(item, index) in hotCourseList"
      :key="index"
    >
      <div class="course_one_top">
        <el-image class="course_one_img" :src="imgPath(item.img)"></el-image>
        <div class="course_one_type">{{ item.type }}</div>
      </div>
      <div class="course_one_title">{{ item.title }}</div>
      <div class="course_one_institution flex FlexBetween">
        <div class="course_one_institution_left flex Flexalign">
          <el-avatar :size="24" :src="item.institutionIcon" />
          <div class="institutionName">{{ item.institutionName }}</div>
        </div>
        <div class="course_num">{{ item.courseNum }}课时</div>
      </div>
      <div class="course_rate flex FlexBetween Flexalign">
        <el-rate
          v-model="item.rateValue"
          disabled
          show-score
          text-color="#666666"
          score-template="{value}分"
        />
        <div class="course_online">{{ item.onlineNum }}人正在学习</div>
      </div>
      <!-- <div class="flex FlexBetween Flexalign course_info">
        <div class="course_online">{{ item.onlineNum }}人正在学习</div>
        <div class="course_price">
          <span class="course_price_unit">￥</span>{{ item.price }}
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "GjkcH5CourseList",

  data() {
    return {
      hotCourseList: [
        {
          img: "course_img.png",
          type: "会员专享",
          title: "实数的概念",
          institutionIcon: "course_img.png",
          institutionName: "圆梦教育机构",
          courseNum: 34,
          rateValue: 5,
          onlineNum: 572,
          price: 1999.99,
        },
        {
          img: "course_img.png",
          type: "会员专享",
          title: "实数的概念",
          institutionIcon: "course_img.png",
          institutionName: "圆梦教育机构",
          courseNum: 34,
          rateValue: 5,
          onlineNum: 572,
          price: 1999.99,
        },
        {
          img: "course_img.png",
          type: "会员专享",
          title: "实数的概念",
          institutionIcon: "course_img.png",
          institutionName: "圆梦教育机构",
          courseNum: 34,
          rateValue: 5,
          onlineNum: 572,
          price: 1999.99,
        },
        {
          img: "course_img.png",
          type: "会员专享",
          title: "实数的概念",
          institutionIcon: "course_img.png",
          institutionName: "圆梦教育机构",
          courseNum: 34,
          rateValue: 5,
          onlineNum: 572,
          price: 1999.99,
        },
        {
          img: "course_img.png",
          type: "会员专享",
          title: "实数的概念",
          institutionIcon: "course_img.png",
          institutionName: "圆梦教育机构",
          courseNum: 34,
          rateValue: 5,
          onlineNum: 572,
          price: 1999.99,
        },
        {
          img: "course_img.png",
          type: "会员专享",
          title: "实数的概念",
          institutionIcon: "course_img.png",
          institutionName: "圆梦教育机构",
          courseNum: 34,
          rateValue: 3.9,
          onlineNum: 572,
          price: 1999.99,
        },
        {
          img: "course_img.png",
          type: "会员专享",
          title: "实数的概念",
          institutionIcon: "course_img.png",
          institutionName: "圆梦教育机构",
          courseNum: 34,
          rateValue: 5,
          onlineNum: 572,
          price: 1999.99,
        },
        {
          img: "course_img.png",
          type: "会员专享",
          title: "实数的概念",
          institutionIcon: "course_img.png",
          institutionName: "圆梦教育机构",
          courseNum: 34,
          rateValue: 5,
          onlineNum: 572,
          price: 1999.99,
        },
      ],
    };
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
.course_list {
  width: $pageMainWidth;
  .course_one {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    border: 1px solid #e3e3e3;
    padding: 11px;
    box-sizing: border-box;
    // height: 309px;
    margin-top: 12px;
    .course_one_top {
      position: relative;
      .course_one_img {
        width: 265px;
        height: 148px;
      }
      .course_one_type {
        position: absolute;
        right: 0;
        top: 0;
        width: 84px;
        height: 21px;
        background: linear-gradient(90deg, #FDEACB, #EABC80);
        border-radius: 0px 20px 0px 20px;
        font-size: 14px;
        color: #875427;
        text-align: center;
      }
    }
    .course_one_title {
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      margin: 5px 0;
    }
    .course_one_institution {
      .course_one_institution_left {
        .institutionName {
          color: #333333;
          margin-left: 6px;
        }
      }
      .course_num {
        color: #666666;
      }
    }
    .course_rate {
      :deep(.el-rate .el-rate__icon) {
        margin-right: 0;
      }
    }
    .course_info {
      .course_online {
        font-size: 14px;
        color: #999999;
      }
      .course_price {
        color: #ff6619;
        font-size: 22px;
        font-weight: 600;
        .course_price_unit {
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>